<template>
  <v-select
    v-model="localValue"
    variant="solo"
    menu-icon="mdi-chevron-down"
    clear-icon="mdi-close"
    class="ag-select"
    persistent-hint
    :hide-details="hideDetails"
    :hint="hint"
    :item-title="itemText"
    :item-value="itemValue"
    :items="items"
    :label="localLabel"
    :placeholder="placeholder"
    :disabled="disabled"
    :menu-props="{ bottom: true, offsetY: true }"
    :rules="rules"
    :data-message-color="messageColor"
  >
    <template #item="{ props, item }">
      <v-list-item v-bind="props" style="height: 64px" :disabled="item.raw.disabled">
        <template #title>
          <span>{{ item.title }}</span>
        </template>

        <template v-if="item.raw.tag" #append>
          <AGTag class="ml-4" small :type="item.raw.tag.type || 'primary'" :label="item.raw.tag.label" />
        </template>
      </v-list-item>
    </template>
  </v-select>
</template>

<script>
import AGTag from '@/components/common/AGTag.vue';
import { MESSAGE_COLOR } from '@/constants/ConstantMessageColor';
import { uniqueId } from 'lodash';

export default {
  components: { AGTag },

  emits: ['update:modelValue', 'change'],

  props: {
    id: {
      type: String,
      default: uniqueId('_agselect'),
    },

    label: {
      type: String,
      required: true,
    },

    items: {
      type: Array,
      required: true,
    },

    itemText: {
      type: [String, Function],
      default: 'text',
    },

    itemValue: {
      type: [String, Function],
      default: 'value',
    },

    modelValue: {
      type: [Boolean, String, Number, Array, Object],
      default: null,
    },

    placeholder: {
      type: String,
      default: 'Selecione uma opção',
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    rules: {
      type: Array,
      default: () => [],
    },

    hideDetails: {
      type: [Boolean, String],
      default: 'auto',
    },

    hint: {
      type: String,
      default: undefined,
    },

    messageColor: {
      type: String,
      default: MESSAGE_COLOR.DEFAULT,
      validator: (val) => Object.values(MESSAGE_COLOR).includes(val),
    },
  },

  computed: {
    localValue: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit('update:modelValue', val);
        this.$emit('change', val);
      },
    },

    campoObrigatorio() {
      return this.rules.some((rule) => rule?.name?.toLowerCase().includes('required'));
    },

    localLabel() {
      return `${this.label}${this.campoObrigatorio ? ' *' : ''}`;
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/styles/input.scss';
@import '@/styles/select.scss';
</style>
